export default {
  // awardsData: (state) => state.awardsResult?.awardsData,
  // filterForm: (state) => state.awardsResult?.filterForm,
  awardsData: (state) => state.awardsData,
  filterForm: (state) => state.filterEngine,
  filterVersion: (state) => state.filterVersion,
  filterGroups: (state, getters) => {
    if (!state.filterEngine) {
      return [];
    }
    return Array
      .from(state.filterEngine.indexes.groupsById.values())
      .filter((group) => {
        const fields = getters.fieldsByGroupId(group.profileGroupId);
        return fields && fields.length > 0;
      })
      .sort((a, b) => a.groupOrder - b.groupOrder);
  },
  fieldsByGroupId: (state) => (groupId) => {
    if (!state.filterEngine) {
      return [];
    }
    return state.filterEngine
      .getFieldsByGroup(groupId)
      .slice()
      .sort((a, b) => a.fieldOrder - b.fieldOrder);
  },
  visibleValues: (state) => (fieldId) => {
    if (!state.filterEngine) {
      return [];
    }
    return state.filterEngine.getVisibleValues(fieldId);
  },
  isSelected: (state) => (fieldId, valueId) => {
    if (!state.filterEngine) {
      return [];
    }
    return state.filterEngine.isSelected(fieldId, valueId);
  },
  selectedFilters: (state) => state.selectedFilters,
};
